import type { ReactNode } from 'react';
import kyumoLogo from '../assets/kyumo.png';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="w-full max-w-md">
      <div className="bg-card/80 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-border">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <img src={kyumoLogo} alt="Kyumo Logo" className="w-20 h-20" />
          </div>
          <h1 className="text-2xl font-bold text-foreground mb-2">{title}</h1>
          {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
        </div>
        {children}
      </div>
      <div className="mt-6 text-center">
        <div className="flex items-center justify-center gap-1.5">
          <p className="text-muted-foreground text-xs">きゅーもAI エージェント</p>
          {import.meta.env.VITE_APP_ENVIRONMENT &&
            import.meta.env.VITE_APP_ENVIRONMENT !== 'prod' && (
              <span className="px-1 py-px text-[9px] font-medium rounded bg-orange-500 text-white">
                {import.meta.env.VITE_APP_ENVIRONMENT.toUpperCase()}
              </span>
            )}
        </div>
      </div>
    </div>
  );
}
